import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { from, mergeMap, Observable, of, take } from 'rxjs';
import { AuthService } from '../core/auth.service';
import { SessionService } from '../core/session.service';

@Injectable({ providedIn: 'root' })
export class CompanyPickerGuard implements CanActivate {
  constructor(
    private sessionService: SessionService,
    private authService: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return this.authService.isLoggedIn(null).pipe(
      take(1),
      mergeMap((isLoggedIn) => {
        if (isLoggedIn) {
          if (this.sessionService.currentCompanyId) {
            return this.sessionService.changeCurrentCompany(null);
          }
          return of(true);
        }
        return from(this.authService.totalLogout().then(() => true));
      })
    );
  }
}
